var map = {
	"./activities_banner.jpg": 4222,
	"./contact_banner.jpg": 7777,
	"./dolasab_beach.jpg": 7846,
	"./home_banner.jpg": 8860,
	"./home_banner_old.jpeg": 6015,
	"./photos_banner.jpg": 9654,
	"./room_banner.jpg": 3880,
	"./rules_banner.jpg": 8278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 746;